// extracted by mini-css-extract-plugin
export default {"st_header":"global_st_header__fQ+5-"};